import config from '../../config';
import React from 'react';
import PropTypes from 'prop-types';

const BookingPerson = ({ person, onClick }) => {
    if (!person) return null;

    return(
        <div className='person' onClick={() => onClick(person.id)}>
            <img src={`${config.server}/${person.imagePath}`} alt='Person billede' />
            <div className='person-name'>{person.name}</div>
        </div>
    )
};

BookingPerson.propTypes = {
    person: PropTypes.object,
    onClick: PropTypes.func
};

export default BookingPerson;